import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { getTranslations } from '@translations';
import { ProductFamiliesPropType } from '@propTypes';
import {
  Button,
  Dropdown,
  DropdownLayover,
  DropdownTrigger,
  Icon,
} from '@components';
import Family from './Family';
import Category from './Category';
import Subcategory from './Subcategory';
import { PRODUCT_MENU_STATE_ENUM } from './constants';

import styles from './styles/index.module.scss';

const { FAMILIES, CATEGORIES, SUBCATEGORIES } = PRODUCT_MENU_STATE_ENUM;

const Product = ({ products, className }) => {
  const translations = getTranslations();
  const [menuState, setMenuState] = useState(FAMILIES);
  const [idSelectedFamily, setIdSelectedFamily] = useState('');
  const [idSelectedCategory, setIdSelectedCategory] = useState('');
  const [subcategories, setSubcategories] = useState([]);
  const [isVisible, setIsVisible] = useState(false);

  const onShowCategoryMenu = ({ id }) => {
    setIdSelectedFamily(id);
    setIdSelectedCategory('');
    setMenuState(CATEGORIES);
  };

  const onShowSubcategoryMenu = ({ id, children }) => {
    setMenuState(SUBCATEGORIES);
    setIdSelectedCategory(id);
    setSubcategories(children);
  };

  const resetMenu = () => {
    setIdSelectedCategory('');
    setIdSelectedFamily('');
    setMenuState(FAMILIES);
  };

  const isHiddenCategory = id =>
    id === idSelectedFamily ? undefined : styles.hiddenCategory;

  const subMenuClassName =
    menuState === FAMILIES ? styles.subMenuHidden : styles.subMenuShown;

  const dropdownClassName =
    menuState === FAMILIES ? styles.dropdown : styles.dropdownWithSubMenu;

  return (
    <div className={className}>
      <Dropdown
        className={dropdownClassName}
        onMouseLeave={resetMenu}
        setIsVisible={setIsVisible}
      >
        <DropdownTrigger>
          <Button
            color="transparent"
            className={styles.productTab}
            data-qa="selectProductsCta"
          >
            <Icon size="24" id="hammer" className={styles.productIcon} />
            <span className={styles.productText}>
              {translations('header.subheader.products.text')}
            </span>
          </Button>
        </DropdownTrigger>
        <DropdownLayover>
          <div className={styles.menu} data-qa="productsLayover">
            <Family
              products={products}
              onShowCategoryMenu={onShowCategoryMenu}
              idSelectedFamily={idSelectedFamily}
              isVisible={isVisible}
            />
            <div className={subMenuClassName}>
              <ul className={styles.categoriesContainer}>
                {products.map(({ id, children }) => (
                  <li className={isHiddenCategory(id)} key={id}>
                    <Category
                      categories={children}
                      onShowSubcategoryMenu={onShowSubcategoryMenu}
                      idSelectedCategory={idSelectedCategory}
                    />
                  </li>
                ))}
              </ul>
              <Subcategory
                menuState={menuState}
                subcategories={subcategories}
              />
            </div>
          </div>
        </DropdownLayover>
      </Dropdown>
      <div className={styles.hiddenCategory}>
        <Family
          products={products}
          onShowCategoryMenu={onShowCategoryMenu}
          idSelectedFamily={idSelectedFamily}
          isVisible={isVisible}
        />
        <ul>
          {products.map(({ id, children }) => (
            <li key={id}>
              <Category
                categories={children}
                onShowSubcategoryMenu={onShowSubcategoryMenu}
                idSelectedCategory={idSelectedCategory}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

Product.propTypes = {
  products: ProductFamiliesPropType.isRequired,
  className: PropTypes.string,
};

Product.defaultProps = {
  className: null,
};

export default Product;
